import React from 'react'
import styled from 'styled-components'
import { useProductsQuery } from '@mote/api'
import { useGoalsState } from '@mote/helpers/hooks/business'
import { useAuth } from '../../auth/useAuth'
import { ProductData } from '../Pricing/product.data'
import {
  StepError as Error,
  SurveyError as StateError,
  UpsellCard,
  UpsellContent
} from './components'
import { useOnboarding } from './context'

export const OnboardingUpsell = () => {
  const goalsState = useGoalsState()
  const { user } = useAuth()
  const { state } = useOnboarding()
  const [error, setError] = React.useState(false)
  const isMinor = React.useMemo(
    () =>
      state.survey.is_minor ? !!state.survey.is_minor[0].value : user?.isMinor,
    [user, state]
  )
  const isStudent = React.useMemo(() => state.role === 'student', [state.role])
  const shouldSkipProducts = React.useMemo(
    () =>
      goalsState.onboardingComplete ||
      goalsState.userOnboardingSkipped ||
      user?.isInstitutional ||
      user?.isPaid ||
      isMinor ||
      isStudent,
    [user, isStudent, isMinor, goalsState]
  )
  const {
    data: rawProducts,
    loading: isProductsLoading,
    error: productsError
  } = useProductsQuery({
    enabled: !shouldSkipProducts
  })
  const [products, setProducts] = React.useState(null)

  React.useEffect(() => {
    if (
      shouldSkipProducts ||
      isProductsLoading ||
      productsError ||
      !rawProducts ||
      products
    )
      return

    const newProducts = new ProductData(true, rawProducts)

    setProducts(newProducts)
  }, [
    products,
    isProductsLoading,
    productsError,
    rawProducts,
    shouldSkipProducts
  ])

  function handleError(error) {
    setError(error)
  }

  return (
    <>
      {productsError && (
        <StateError>
          Something funky happened and we couldn't load the page. It could be a
          network problem on your end or a server problem on our end. Please try
          again!
        </StateError>
      )}
      {!productsError && (
        <>
          {error && (
            <StyledError message='Something went wrong while processing your request. Please try again!' />
          )}
          <UpsellCard
            align='flex-start'
            justify='flex-start'
            gap={24}
            hasError={error}
          >
            <UpsellContent
              products={products}
              isMinor={isMinor}
              isStudent={isStudent}
              hasError={error}
              onError={handleError}
            />
          </UpsellCard>
        </>
      )}
    </>
  )
}

const StyledError = styled(Error)`
  margin-top: 40px;

  @media (max-width: 639px) {
    margin-top: 24px;
  }
`
